<template>
  <div class="viewDialog">
    <BaseDialog
      title="添加挂号"
      :isshow="visible"
      @handleShow="
        (val) => {
          visible = val
        }
      "
      width="710"
      height="auto"
    >
      <div class="patentList fatherHeight contBox">
        <div>
          <div class="search-top" style="margin-top: 10px">
            <div class="bar-title">挂号信息</div>
            <el-form
              :inline="true"
              :model="ruleForm"
              :rules="JsRule"
              :label-width="100"
            >
              <!-- <el-row>
                <el-col span="12"> -->
              <el-form-item label="挂号医生：" prop="doctor_id">
                <el-select v-model="ruleForm.doctor_id" placeholder="请选择">
                  <el-option
                    v-for="item in dictList.duty_doctor"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- </el-col>
                <el-col span="12"> -->
              <el-form-item label="挂号时间：">
                <el-date-picker
                  v-model="ruleForm.bed_time"
                  type="datetime"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择挂号时间"
                >
                </el-date-picker>
              </el-form-item>
              <!-- </el-col>
              </el-row>
              <el-row> -->
              <!-- <el-col span="12"> -->
              <el-form-item label="结算类别：" prop="dict_pay_cate">
                <el-select
                  @change="dictPayCateChange"
                  v-model="ruleForm.dict_pay_cate"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in resultList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- </el-col> -->
              <!-- <el-col span="12" > -->
              <el-radio-group
                v-if="ruleForm.dict_pay_cate == '4040'"
                v-model="ruleForm.card_type"
                class="ml-4"
                @change="registTypeChange"
              >
                <el-radio label="1" size="large">身份证</el-radio>
                <el-radio label="2" size="large">医保码</el-radio>
                <el-radio label="3" size="large">医保卡/社保卡</el-radio>
              </el-radio-group>
              <!-- </el-col>
              </el-row> -->
            </el-form>
          </div>
          <el-divider></el-divider>
        </div>
        <div
          class="patientList"
          v-if="ruleForm.card_type == 3 && ruleForm.dict_pay_cate == '4040'"
        >
          <div>
            <el-button @click="getCardInfo" type="success"
              >获取读卡信息</el-button
            >
          </div>
          <el-descriptions
            v-loading="loading"
            style="margin-top: 10px"
            class="margin-top"
            :column="2"
            size="small"
            border
          >
            <el-descriptions-item label-class-name="cell-label">
              <template #label>
                <div class="cell-item">社保机构编码</div>
              </template>
              {{ cardInfo.org_no ? cardInfo.org_no : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">社保卡卡号</div>
              </template>
              {{ cardInfo.card_no ? cardInfo.card_no : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">银行账号</div>
              </template>
              {{ cardInfo.bank_no ? cardInfo.bank_no : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">身份证号</div>
              </template>
              {{ cardInfo.cert_no ? cardInfo.cert_no : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">姓名</div>
              </template>
              {{ cardInfo.name ? cardInfo.name : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">性别</div>
              </template>
              {{ cardInfo.sex ? cardInfo.sex : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">民族</div>
              </template>
              {{ cardInfo.nat ? cardInfo.nat : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">出生日期</div>
              </template>
              {{ cardInfo.birthday ? cardInfo.birthday : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">识别码</div>
              </template>
              {{ cardInfo.code ? cardInfo.code : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">设备序列号</div>
              </template>
              {{ cardInfo.sn ? cardInfo.sn : '--' }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">卡规范版本号</div>
              </template>
              {{ cardInfo.version ? cardInfo.version : '--' }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div
          class="patientList"
          v-if="ruleForm.card_type == 2 && ruleForm.dict_pay_cate == '4040'"
        >
          <saoma ref="saomaRef" @refreshData="setSaoma"></saoma>
          <div class="name">
            患者姓名：{{ ruleForm.userName ? ruleForm.userName : '未知' }}
          </div>
          <div class="name">
            患者身份证号：{{ ruleForm.idNo ? ruleForm.idNo : '未知' }}
          </div>
        </div>
        <div
          class="patientList"
          v-if="ruleForm.card_type == 1 && ruleForm.dict_pay_cate == '4040'"
        >
          <div class="search-top">
            <el-form
              :inline="true"
              :model="formData"
              ref="searchForm"
              class="demo-form-inline"
              :label-width="80"
              label-suffix=":"
            >
              <el-form-item label="姓名">
                <el-input
                  v-model="pageData.keyword"
                  type="text"
                  clearable
                  placeholer="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input
                  v-model="pageData.cert_no"
                  type="text"
                  clearable
                  placeholer="请输入"
                ></el-input>
              </el-form-item>
              <div class="searchBut">
                <el-button @click="search" class="color-main" type="primary">
                  <i class="fa fa-search"></i>查询
                </el-button>
              </div>
            </el-form>
          </div>
          <div class="table">
            <el-table
              v-loading="dataListLoading"
              :data="tableData"
              :row-style="rowStyle"
              ref="tableBoxRef"
              class="table-ellipsis"
              v-if="istable"
              @row-click="Rowclick"
              size="small"
              border
              @select-all="handleSelectionChange"
              @select="tableSelect"
            >
              <el-table-column
                prop="name"
                label="姓名"
                show-overflow-tooltip
                width="180"
              />
              <el-table-column
                prop="dict_sex_name"
                label="性别"
                show-overflow-tooltip
                width="80"
              />
              <el-table-column
                prop="age"
                label="年龄"
                show-overflow-tooltip
                width="80"
              />
              <el-table-column
                prop="cert_no"
                label="身份证号"
                show-overflow-tooltip
              />
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination
              :currentPage="pageData.currentPage"
              :page-size="pageData.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSum"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
        <div class="patientList" v-if="ruleForm.dict_pay_cate == '1001'">
          <div class="search-top">
            <el-form
              :inline="true"
              :model="formData"
              ref="searchForm"
              class="demo-form-inline"
              :label-width="80"
              label-suffix=":"
            >
              <el-form-item label="姓名">
                <el-input
                  v-model="pageData.keyword"
                  type="text"
                  clearable
                  placeholer="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input
                  v-model="pageData.cert_no"
                  type="text"
                  clearable
                  placeholer="请输入"
                ></el-input>
              </el-form-item>
              <div class="searchBut">
                <el-button @click="search" class="color-main" type="primary">
                  <i class="fa fa-search"></i>查询
                </el-button>
              </div>
            </el-form>
          </div>
          <div class="table">
            <el-table
              v-loading="dataListLoading"
              :data="tableData"
              :row-style="rowStyle"
              ref="tableBoxRef"
              class="table-ellipsis"
              v-if="istable"
              @row-click="Rowclick"
              size="small"
              border
              @select-all="handleSelectionChange"
              @select="tableSelect"
            >
              <el-table-column
                prop="name"
                label="姓名"
                show-overflow-tooltip
                width="180"
              />
              <el-table-column
                prop="dict_sex_name"
                label="性别"
                show-overflow-tooltip
                width="80"
              />
              <el-table-column
                prop="age"
                label="年龄"
                show-overflow-tooltip
                width="80"
              />
              <el-table-column
                prop="cert_no"
                label="身份证号"
                show-overflow-tooltip
              />
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination
              :currentPage="pageData.currentPage"
              :page-size="pageData.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSum"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="reset">
            取消
          </el-button>
          <el-button
            @click="savePatient"
            :loading="saveLoad"
            class="color-determine"
            type="primary"
          >
            确定
          </el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>
<script setup name="jieShuan">
import {
  reactive,
  toRefs,
  ref,
  nextTick,
  onMounted,
  onBeforeUnmount,
  defineEmits,
} from 'vue'
import saoma from '../saomadun'
import readCard from '../readCard'
import { useRouter, useRoute } from 'vue-router'
import service from '@/utils/request'
import { chineseNumber } from '@/utils/tool'
import { ElMessageBox, ElMessage } from 'element-plus'
import BaseDialog from '@/components/Dialog/index.vue'
import list from '../patient/Details/dialysis/vascularAccess/list'
const visible = ref(false)
const saveLoad = ref(false)
const loading = ref(false)
const emit = defineEmits(['jsConfirm'])
const info = ref({})
const dictList = ref({})
const totalMoney = ref(0)
const totalMoneyBig = ref(0)
const free = ref({ yao: 0, hao: 0, zhi: 0 })
const idRow = ref('')
const JsRule = ref({
  doctor_id: [{ required: true, trigger: 'blur', message: '请选择' }],
  dict_pay_cate: [{ required: true, trigger: 'blur', message: '请选择' }],
})
const cardInfo = ref({})
const setSaoma = (item) => {
  ruleForm.value.scan_ec_token = item.data.ecToken
  ruleForm.value.userName = item.data.userName
  ruleForm.value.idNo = item.data.idNo
}
const dictPayCateChange = (e) => {
  ruleForm.value.dict_pay_cate = e
  if (ruleForm.value.dict_pay_cate == '4040') {
    ruleForm.card_type.value = '1'
  }
}
const resultList = [
  {
    id: '1',
    name: '自费',
    code: '1001',
  },
  {
    id: '2',
    name: '医保',
    code: '4040',
  },
]
//添加颜色
const rowStyle = (row) => {
  if (idRow.value === row.row.id) {
    return { 'background-color': '#ccc', cursor: 'pointer', color: '#333' }
  }
  return { cursor: 'pointer' }
}
const registTypeChange = (e) => {
  ruleForm.card_type.value = e
}
// 左侧表格点击
const Rowclick = (row) => {
  idRow.value = row.id
  ruleForm.value.patient_id = row.patient_id
}
async function savePatient() {
  saveLoad.value = true
  let res = await service.post('/api/bedReg/createNormal', ruleForm.value)
  if (res.code === 0) {
    saveLoad.value = false
    ElMessage.success(res.msg)
    visible.value = false
    emit('jsConfirm')
    ruleForm.value.doctor_id = ''
    ruleForm.value.bed_time = ''
    ruleForm.value.dict_pay_cate = ''
    idRow.value = ''
    ruleForm.card_type.value = 1
  } else {
    saveLoad.value = false
  }
}
// 复选框
function handleSelectionChange(e) {
  if (e.length > 0) {
    e.forEach((item1) => {
      if (!tableSelected.value.some((item2) => item2.id == item1.id)) {
        tableSelected.value.push(item1)
      }
    })
  } else {
    tableData.value.forEach((item1, index1) => {
      let findIndex = tableSelected.value.findIndex(
        (item2) => item2.id == item1.id
      )
      if (findIndex > -1) {
        tableSelected.value.splice(findIndex, 1)
      }
    })
  }
}
function tableSelect(e, row) {
  tableData.value.forEach((item1, index1) => {
    tableSelected.value.splice(index1, 1)
  })
  e.forEach((item1) => {
    if (!tableSelected.value.some((item2) => item2.id == item1.id)) {
      tableSelected.value.push(item1)
    }
  })
}
function clearSelection() {
  tableBoxRef.value.clearSelection()
}
const getDoctorList = async () => {
  let res = await service.post('/api/user/list', {
    role_id: 1,
  })
  if (res.code === 0) {
    dictList.value.duty_doctor = res.data.records
  }
}
const searchData = ref({
  case_no: '',
  name: '',
  cert_no: '',
  birth_date: '',
  dict_medical_cate: '',
  doctor_id: '',
  dict_department: '',
})
const formData = ref({})
const ruleForm = ref({})
const initData = () => {
  ruleForm.value.bed_time = timestampToTime()
}
//获取当前时间
const timestampToTime = () => {
  let date = new Date()
  let year = date.getFullYear() + '-'
  var M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return year + M + D + h + m + s
}
const pageData = ref({
  name: '',
  cert_no: '',
  current: 1,
  size: 10,
})
const dataListLoading = ref(false)
const tableData = ref([])
const tableSelected = ref([])
const searchForm = ref({})
const statistic = ref('')
const istable = ref(true)
const tableBoxRef = ref(null)
const tableHei = ref(0)
const totalSum = ref(0)

const getDataList = () => {
  dataListLoading.value = true
  service.post('/api/patient/get_patient_list', pageData.value).then((res) => {
    tableData.value = res.data.records
    totalSum.value = res.data.total
    if (tableBoxRef.value) {
      tableData.value.forEach((item, index) => {
        if (tableSelected.value.some((item2) => item2.id == item.id)) {
          nextTick(function () {
            tableBoxRef.value.toggleRowSelection(item, true)
          })
        }
      })
    }
  })
  dataListLoading.value = false
}

// 医保读卡
const getCardInfo = async () => {
  loading.value = true
  let res = await service.post('/api/common/getCardInfo')
  if (res.code === 0) {
    cardInfo.value = res.data.card_info
    ruleForm.value.patient_id = res.data.card_info.patient_id
    ruleForm.value.card_no = res.data.card_info.card_no
  }
  loading.value = false
}

function handleSizeChange(e) {
  pageData.value.size = e
  pageData.value.current = 1
  getDataList()
}
function handleCurrentChange(e) {
  pageData.value.current = e
  getDataList()
}
function search(e) {
  pageData.value.current = 1
  getDataList()
}
function reset() {
  //clearSelection()
  idRow.value = []
  visible.value = false
  for (const key in ruleForm.value) {
    ruleForm.value[key] = ''
  }
  ruleForm.card_type = 1
  tableSelected.value = []
  cardInfo.value = {}
}

getDoctorList()
getDataList()
defineExpose({
  visible,
  info,
  getDataList,
  reset,
  getDoctorList,
  initData,
})
</script>
<style lang="scss">
.el-notification__group {
  flex: 1;
}

.notice_but {
  text-align: right;
  color: #3167a8;
  cursor: pointer;
}
</style>
<style scoped lang="scss">
.cell-label {
  width: 100px;
}
.demo-form-inline {
  margin-top: 0;
  //flex: 1;
  display: grid;
  grid-template-columns: 40% 40% 20%;
  grid-row-gap: 10px;
  //grid-template-rows: repeat(4, 40px);
  align-items: center;

  .el-form-item {
    margin-bottom: 0;
  }
}

.search-top .w-208 {
  width: 208px;
}

.table-tag {
  margin-right: 8px;
}

.fa-stack {
  width: 24px;
  height: 24px;
  cursor: pointer;
  float: right;

  .fa-stack-2x {
    font-size: 24px;
    color: rgba(49, 102, 174, 0.1);
  }

  .fa-stack-1x {
    font-size: 12px;
    color: #3166ae;
    line-height: 24px;
  }
}

.tagBox {
  display: flex;
  justify-content: flex-start;

  // margin-bottom: 10px;
  .tit {
    width: 83px;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Bold';
    font-weight: bold;
    color: #666666;
  }

  .cont {
    width: calc(100% - 83px);
  }
}

.patientList {
  margin-top: 4px;
  height: calc(100% - 45px);
  .cell-label {
    width: 100px;
  }
}

.list-top {
  .name {
    font-size: 18px;
    font-family: ' Source Han Sans CN-Medium';
    font-weight: 500;
    color: #000000;
    line-height: 32px;
  }
}

.patient-alert {
  background: rgba(49, 102, 174, 0.1);
  border-radius: 4px 4px 4px 4px;
  font-size: 18px;
  color: #3166ae;
  margin-top: 8px;
  padding: 4px 16px;

  .el-alert__icon {
    color: #3166ae;
  }

  &:deep(.el-alert__content) {
    position: relative;
    top: 3px;
  }
}

.table {
  margin-top: 10px;
  height: calc(100% - 82px);

  .img {
    width: 25px;
    height: 24px;
    margin-right: 14px;
  }
}

.searchBut {
  width: 100%;
  //margin-left: 20px;
  //margin-right: 29px;
  justify-self: right;
  display: flex;
  justify-content: end;
  margin-right: 28px;
}

.del {
  background-color: #ffecec;
  color: #ff6b6b;
  font-weight: 700;
}

.modify {
  background-color: #3166ae;
}

.bar-title {
  font-size: 16px;
  line-height: 18px;
  color: #000000;
  border-left: 6px solid #3166ae;
  padding: 0 18px;
  margin-bottom: 16px;
}

.momey-total {
  display: flex;
  margin: 10px;
  line-height: 30px;

  .item {
    margin-right: 20px;
    width: 150px;
  }

  .item1 {
    width: 300px;
  }
}

.radio-bg {
  background: rgba(49, 102, 174, 0.1);
  padding: 0px 10px;
  border-radius: 4px;
}
</style>